export const REQUIRED_MESSAGE = 'This field is required';
